import { useSite, UI, resolveImg } from "@/lib/site";
import { MaskLine, Reveal } from "@/components/Reveal";

export const Why = () => {
  const { t, content } = useSite();
  const items = Array.isArray(content?.why) ? content.why : [];
  return (
    <section data-testid="why-section" className="relative bg-[#fbf7ef] px-5 py-24 md:px-10 md:py-36">
      <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <p className="eyebrow">{t(UI.why)}</p>
            <h2 className="font-display mt-6 text-4xl font-medium leading-[1.02] text-[#1d1712] sm:text-5xl lg:text-6xl">
              <MaskLine inView>{t(UI.why)}</MaskLine>
            </h2>
            <p className="font-display mt-6 text-2xl italic text-[#5c3f17]">{t(UI.whyLead)}</p>
            <Reveal className="mt-10 overflow-hidden rounded-[26px]">
              <img src={resolveImg(content?.whyImage)} alt="Dari Event team" loading="lazy" className="aspect-[3/2] w-full object-cover" data-testid="why-team-photo" />
            </Reveal>
          </div>
        </div>
        <ol className="lg:col-span-7">
          {items.map((w, i) => (
            <Reveal as="li" key={i} delay={0.04 * i} className="group grid grid-cols-[3.5rem_1fr] gap-4 border-t border-[#b8893b]/25 py-8 last:border-b md:grid-cols-[6rem_1fr] md:py-10" data-testid={`why-item-${i}`}>
              <span className="font-display text-4xl text-[#b8893b] transition-transform duration-500 group-hover:-translate-y-1 md:text-6xl">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h3 className="font-display text-2xl font-medium text-[#1d1712] transition-colors duration-500 group-hover:text-[#8a6424] md:text-4xl">{t(w.title)}</h3>
                <p className="mt-2 text-[0.95rem] leading-relaxed text-[#5b4f43]">{t(w.text)}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
